import { EXTERNAL_SYNC_PROVIDERS } from 'shared/constants';
import {
  PolicytechBinderIcon,
  PolicytechIcon,
  SharepointBinderIcon,
  SharepointIcon,
} from '../images/items';

const externalSyncToIconsMapper = {
  [EXTERNAL_SYNC_PROVIDERS.SHAREPOINT]: SharepointIcon,
  [EXTERNAL_SYNC_PROVIDERS.POLICYTECH]: PolicytechIcon,
};

const externalSyncToBinderIconsMapper = {
  [EXTERNAL_SYNC_PROVIDERS.SHAREPOINT]: SharepointBinderIcon,
  [EXTERNAL_SYNC_PROVIDERS.POLICYTECH]: PolicytechBinderIcon,
};

export const getExternalSyncIcon = provider => externalSyncToIconsMapper[provider];
export const getExternalSyncBinderIcon = provider => externalSyncToBinderIconsMapper[provider];
